import * as constants from '@/common/constants';
import { get } from '@/utils/http';

// 帮助中心树
export const getHelpCenterTreeList = (params) => {
    return get(constants.API_HELPCENTER_TREE_LIST, params);
};

export const getHelpCenterContentList = (params) => {
    return get(constants.API_HELPCENTER_CONTENT_LIST, params);
};

export const getFormExtendTreeList = (params) => {
    return get(constants.API_CUSTOM_FORM_EXTEND_TREE_LIST, params);
};



// WEBPACK FOOTER //
// ./src/data-model/help/tree-model.js